import { render } from "./product-detail.vue?vue&type=template&id=663c15ab&scoped=true"
import script from "./product-detail.vue?vue&type=script&lang=js"
export * from "./product-detail.vue?vue&type=script&lang=js"

import "./product-detail.vue?vue&type=style&index=0&id=663c15ab&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-663c15ab"]])

export default __exports__